import React, { useMemo } from 'react';
import { GetLinkData } from '../utils/GetLinkData';
import { ILinkData } from './ILinkData';

/**
 * Matches the link Model in DatoCMS
 */

export const createLinkObject = (link: { _prefix: string; slug: string } | undefined | null) => {
	if (!link) return { internalLink: undefined };
	const constructedLink = {
		internalLink: {
			_prefix: link._prefix,
			slug: link.slug,
		},
	};
	return constructedLink;
};

type LinkProps = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> & {
	data?: ILinkData;
};

export default function Link({ data, ...props }: LinkProps) {
	const link = useMemo(() => {
		if (!data) return;
		return GetLinkData(data);
	}, [data]);

	const handleClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
		ev.preventDefault();
		ev.stopPropagation();

		props.onClick?.(ev);

		link?.open({
			target: ev.ctrlKey ? '_blank' : undefined,
		});
	};

	return (
		<a aria-label={link?.title ?? props.title} {...props} href={link?.href} target={link?.target} onClick={handleClick}>
			{props.children}
		</a>
	);
}
